<template>
  <div class="participants">
    <container>
      <header-group
        heading="Deltagere"
        subheading="Liste over deltagere">
      </header-group>
      <form id="search">
        <label>Søg</label>
        <input name="query" v-model="query" placeholder="E.g. David">
      </form>
      <table-data
        v-if="team"
        :data="team.attendees"
        :columns="columns"
        :filter-key="query"
        @remove="onRemove">
      </table-data>

      <!-- Add attendee -->
      <div class="field">
         <validator name="attendee">
          <form novalidate>
            <h2>Tilføj deltager</h2>
            <div class="input-group">
              <div class="field">
                <label for="name">Deltager</label>
                <input v-model="attendee" v-validate:attendee="{ required: true }" v-on:keyup.enter="addAttendee" type="text">
              </div>
              <div class="field">
                <label for="name">Mail</label>
                <input v-model="mail" v-validate:mail="['required', 'email']" v-on:keyup.enter="addAttendee" type="text">
              </div>
            </div>
            <button class="button pointer-hover" v-if="$attendee.valid" @click="addAttendee">Tilføj deltager</button>
          </form>
        </validator>
      </div>
    </container>
  </div>
</template>

<script>
import { Teams, http } from 'api/resources'
import view from '../mixins/view'

// Components
import HeaderGroup from 'components/HeaderGroup'
import TableData from 'components/TableData'

export default {
  name: 'Participants',
  mixins: [view],
  components: {
    TableData, HeaderGroup
  },
  data () {
    return {
      columns: [],
      query: '',
      team: {},
      attendee: '',
      mail: ''
    }
  },
  computed: {
    id () {
      return this.$route.params.team
    },
    columns () {
      return [
        {
          key: 'id',
          name: '#',
          sort: true
        },
        {
          key: 'name',
          name: 'Navn',
          sort: true
        },
        {
          key: 'email',
          name: 'Mail',
          sort: true
        }
      ]
    }
  },
  methods: {
    addAttendee () {
      if (!this.$attendee.valid) {
        alert('Både navn og mail skal udfyldes')
        return
      }

      this.team.attendees.push({
        name: this.attendee,
        email: this.mail
      })
      this.attendee = ''
      this.mail = ''
      this.save()
    },
    removeAttendee (attendee) {
      this.team.attendees.splice(this.team.attendees.indexOf(attendee), 1)
    },
    save () {
      http.put(`me/teams/${this.id}`, JSON.stringify(this.team)).then(response => {
        console.log(response)
        if (response.ok) {
          this.team = response.data.data
        }
      })
    },
    onRemove (index) {
      this.team.attendees.splice(index, 1)
      this.save()
    }
  },
  asyncComputed: {
    initialTeam () {
      return Teams.get({id: this.id})
      .then(response => {
        const team = response.data.find(team => team.id === parseInt(this.id))
        this.team = team
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#search {
  margin-bottom: 4rem;
}
.table {
  margin-bottom: 8rem;
}
</style>


// WEBPACK FOOTER //
// Participants.vue?9900c2de